(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(98608);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Carousel.js + 5 modules
var Carousel = __webpack_require__(16483);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
;// CONCATENATED MODULE: ./public/static/images/homepage/team-800.jpg
/* harmony default export */ var team_800 = ({"src":"/_next/static/media/team-800.641668fb.jpg","height":426,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAARAAIDBQEhEnGR/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAMAwEAAhEDEQA/AKVtTZtnyb6d8RHB0TSN6PQ8REQvZRy//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/static/images/homepage/hero-1440.jpg
/* harmony default export */ var hero_1440 = ({"src":"/_next/static/media/hero-1440.3fa838a7.jpg","height":764,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIFEQQSAwYh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAMR/9oADAMBAAIRAxEAPwCc6dLyGPI6MyuQh1MOxvyiiIjoolLION//2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/static/images/homepage/counseling.jpg
/* harmony default export */ var counseling = ({"src":"/_next/static/media/counseling.44321307.jpg","height":241,"width":309,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAwEBAQAAAAAAAAAAAAABEQACAwQSIf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIx/9oADAMBAAIRAxEAPwCFz2PHordF66pnxmDUEJFMM/G4iIRybSjf/9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/static/images/homepage/symptoms.jpg
/* harmony default export */ var symptoms = ({"src":"/_next/static/media/symptoms.c66376de.jpg","height":241,"width":309,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAACAwADAAAAAAAAAAAAAAABAgADEQUxUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAMAwEAAhEDEQA/AJrRy96gVkKVVMAzwdRERSY//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/static/images/homepage/psychiatry.jpg
/* harmony default export */ var psychiatry = ({"src":"/_next/static/media/psychiatry.df107622.jpg","height":241,"width":309,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAMBAQAAAAAAAAAAAAADAAECEQQGIROh/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABgRAQEBAQEAAAAAAAAAAAAAAAECAAMh/9oADAMBAAIRAxEAPwCc07aMgMBYuSSZ4DbzFCbWw+21db7aIiJ1uivHN5RLApv/2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/static/images/homepage/assessment.jpg
/* harmony default export */ var assessment = ({"src":"/_next/static/media/assessment.ffbd25b9.jpg","height":242,"width":450,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABBAEFAQAAAAAAAAAAAAACAAEDBCEFBhESEzH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARAv/aAAwDAQACEQMRAD8Asd76nZoyVvAmEpIjbtnkct8RERNZvIYX/9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/static/images/homepage/public.jpg
/* harmony default export */ var homepage_public = ({"src":"/_next/static/media/public.07de0238.jpg","height":241,"width":309,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAACAgIDAAAAAAAAAAAAAAAAAQMRAgQFEzH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEQMRAD8Ai4+W63WOpEr9auwABoNRjV//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/static/images/homepage/groups.jpg
/* harmony default export */ var groups = ({"src":"/_next/static/media/groups.43c4f83c.jpg","height":312,"width":500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIEEQMFEiL/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABYRAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEQMRAD8Aspe02IglzZXnMeOXMvkVRpERBqZW/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/static/images/homepage/marriage.jpg
/* harmony default export */ var marriage = ({"src":"/_next/static/media/marriage.190f893b.jpg","height":280,"width":450,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAdEAACAgIDAQAAAAAAAAAAAAABAgAEAxEFEyFx/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABYRAQEBAAAAAAAAAAAAAAAAAAEAIf/aAAwDAQACEQMRAD8AprU04nNbOBmCAjrLjXg+biIhBZmX/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/static/images/homepage/neurofeedback.png
/* harmony default export */ var neurofeedback = ({"src":"/_next/static/media/neurofeedback.19bfb1b9.png","height":400,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEUqMTUhICkiGiEjJS0uQD86VlRFYWKcp+DNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nBXGwRHAQBDCMBvY9F9y5vQSSZokhAG+QEEc23vY3SbaftcS632+WKg/EQ0AhJ8EcrkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/images/homepage/tmc.jpg
/* harmony default export */ var tmc = ({"src":"/_next/static/media/tmc.b6317d32.jpg","height":333,"width":500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAAAP/EAB0QAAEEAgMAAAAAAAAAAAAAAAEAAgMEBREGMUL/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABgRAQADAQAAAAAAAAAAAAAAAAEAAhFx/9oADAMBAAIRAxEAPwBZyZucjydS6x9ipFVMkUBmc1rDoHzrfZCIinXVzkcAbP/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./pages/index.tsx


















var HomePage = function(param) {
    var featuredFaqs = param.featuredFaqs, featuredHeadlines = param.featuredHeadlines, frequentlyIssuesTreated = param.frequentlyIssuesTreated;
    var frequentIssuesTreated = frequentlyIssuesTreated.map(function(service) {
        return {
            text: service.name,
            href: "/services/".concat(service.slug)
        };
    }), headlines = featuredHeadlines, qnas = featuredFaqs;
    /**
   * Meta contents
   */ var metaUrl = constants/* META_URL */.f1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "landing-page",
        "data-testid": "landing-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: hero_1440.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title",
                                children: " Professional Counseling Nets Positive Results "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tagline",
                                children: "Heritage Counseling & Consulting, P.A. is a premier counseling center focused on the total well-being of our clients and patients."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                title: "Phone",
                                "aria-label": "Phone",
                                href: "tel:".concat(constants/* COMPANY_PHONE_NUMBER */.x),
                                className: "btn btn-external btn-main px-5 py-3",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-phone-alt mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Contact Us"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                controls: false,
                interval: 1e4,
                keyboard: false,
                slide: true,
                className: "headline h-div",
                children: headlines.map(function(headline, idx) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default.Item */.Z.Item, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: headline === null || headline === void 0 ? void 0 : (ref = headline.text) === null || ref === void 0 ? void 0 : ref.html
                            }
                        })
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "intro gap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-none d-lg-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "img-responsive",
                                loading: "lazy",
                                src: team_800.src,
                                alt: "Heritage Team",
                                width: "611",
                                height: "481"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "title",
                                    children: "Welcome to Heritage Counseling & Consulting"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Heritage Counseling & Consulting, P.A. is a premier counseling center focused on the total well-being of our clients and patients."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Our approach is to create an attentive, supportive, and professional relationship. We encourage a collaborative approach to treatment, with an emphasis on consulting with current or referred medical providers when necessary to make decisions about treatment plans, including those involving medications."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-5",
                                    children: "Our mission is to provide the most innovative and up to date treatments and services in our field. We approach our work with passion and integrity."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center text-lg-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about",
                                        shallow: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-main btn-cta",
                                            "aria-label": "About",
                                            children: "Read more about us"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "about gap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title",
                            children: "We specialize in meeting the specific and unique needs of each person who enters our practice."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=counseling",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Counseling",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: counseling.src,
                                                    alt: "Counseling Service",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Counseling Service"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=symptoms",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Symptoms",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: symptoms.src,
                                                    alt: "Symptoms Treated",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Symptoms Treated"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=psychiatry",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Psychiatry",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: psychiatry.src,
                                                    alt: "Psychiatry",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Psychiatry"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=alternative+treatment+options",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Neurofeedback",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: neurofeedback.src,
                                                    alt: "Neurofeedback",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Neurofeedback"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=testing+%26+assessment",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Assessment",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: assessment.src,
                                                    alt: "Assessment",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "d-none d-xl-inline",
                                                            children: "Testing &\xa0"
                                                        }),
                                                        "Assessment"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=speaking+engagements",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Public Speaking",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: homepage_public.src,
                                                    alt: "Public Speaking",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Public Speaking"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=group+therapy",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Group Therapy",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: groups.src,
                                                    alt: "Group Therapy",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Group Therapy"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=alternative+treatment+options",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "TMS",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: tmc.src,
                                                    alt: "TMS",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "TMS"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/services?ctg=marriage+retreats",
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "figure-link",
                                        "aria-label": "Marriage Retreats",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "",
                                                    src: marriage.src,
                                                    alt: "Marriage Retreats",
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                    children: "Marriage Retreats"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "athen-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "about fly",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "title",
                                    children: "Our most frequently treated issues include:"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid-container",
                                    children: frequentIssuesTreated.map(function(specialty, idx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: specialty.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-link",
                                                "aria-label": specialty.text,
                                                children: specialty.text
                                            })
                                        }, idx);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "qna-section",
                        itemScope: true,
                        itemType: "https://schema.org/FAQPage",
                        children: [
                            qnas.map(function(qna, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "qna gap",
                                    itemScope: true,
                                    itemProp: "mainEntity",
                                    itemType: "https://schema.org/Question",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "title-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "title",
                                                itemProp: "name",
                                                children: qna.question
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container wrapper",
                                            itemScope: true,
                                            itemProp: "acceptedAnswer",
                                            itemType: "https://schema.org/Answer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "answer",
                                                itemProp: "text",
                                                dangerouslySetInnerHTML: {
                                                    __html: qna.answer.html
                                                }
                                            })
                                        })
                                    ]
                                }, idx);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container text-center mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/faqs",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "btn btn-main btn-cta",
                                        "aria-label": "FAQ",
                                        children: "Read More FAQs"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [598,675,22,483,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);